import { Component } from '@angular/core';
import { Nav, NavController, ToastController, LoadingController, AlertController } from 'ionic-angular';

import { Master, User, Advance, Dashboard } from '@providers/advance_providers/index';
import { LoginPage, ListEmployeePage } from '../index';
import { UserAdvPage } from '../user_adv/page';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  public barChartData:any[] = [
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
  ];
  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartType:string    = 'bar';
  public barChartLegend:boolean = true;


  public doughnutChartLabels:string[] = ["OE < 1 Millions","OE = 1 - 5 Millions","OE =  5 - 25 Millions","OE > 25 Millions","All"];
  public doughnutChartData  :number[] = [0,0,0,0,0];
  public doughnutChartColor = [
    {
      backgroundColor : ["#fff","#f4f4f5","#cdebfd","#b1dc99","#fbdb7a","#ef7596","#f4f4f5"]
    }
  ];
  public doughnutChartType:string = 'doughnut';
  
  user:any = {};

  advanceStat      :any = [];
  dataBar          :any = [];
  listPerDepartment:any = [];
  AllDepartment = 0;

  company             :any = [];
  company_selected         = [];
  company_all_selected:any = 1;

  direktorat              :any = [];
  direktorat_selected          = [];
  direktorat_all_selected :any = 1;
  directorat_selected2         = [];
  
  divisi                 :any = [];
  divisi_selected             = [];
  divisi_all_selected    :any = 1;

  filter_stage             :any = [];
  filter_stage_selected         = [];
  filter_stage_all_selected:any = 1;

  branch                 :any = [];
  branch_selected             = [];
  branch_all_selected    :any = 1;
  
  rate:any     = [ ];
  readyFilter  = 0;

  direksi_user = false;
  divisi_user  = false;
  branch_user  = false;

  advance_type :any;

  constructor(
    public navCtrl    : NavController,
    public toastCtrl  : ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl  : AlertController,
    public masterApi  : Master,
    public userApi    : User,
    public advanceApi : Advance,
    public dashboard  : Dashboard
  ) {
    if(this.userApi.akses.lihat_advance_employee_group_data=='direktorat'){
      this.direksi_user = true;
    }
    if(this.userApi.akses.lihat_advance_employee_group_data=='divisi'){
      this.divisi_user  = true;
    }
    if(this.userApi.akses.lihat_advance_employee_group_data=='branch'){
      this.branch_user  = true;

      this.advance_type = "branch";
    }else{
      this.advance_type = "HO";
    }
    console.log("advance type => ",this.advance_type);

  }
  

  ionViewWillEnter() {
    if(!this.userApi.akses.lihat_advance_employee){
      this.navCtrl.setRoot(UserAdvPage, {
        params : {}
      });
    }
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getDataAdvanceStat();
  }

  ionViewDidLoad() {
    this.getCompany();
    this.getDirektorat();
    this.getDivisi();
    this.getRate();
    this.getBranch();
    this.getDataAdvanceStat();
  }

  public getCompany(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.getCompany(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
            rec.selected = 1;      
            this.company_selected.push(rec.id);
      });
      console.log(this.company_selected);
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      this.company = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
  
  public getDirektorat(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.getDirektorat(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.direksi_user || this.divisi_user){
          if(this.userApi.data.directorat_maping_id==rec.maping_id){
            rec.selected = 1;
            this.direktorat_selected.push(rec.maping_id);
          }
        }else{
          rec.selected = 1;
          this.direktorat_selected.push(rec.maping_id);
        }
      });
      console.log(this.direktorat_selected);
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      this.direktorat = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getDivisi(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params :any = {};
    if(this.direksi_user || this.divisi_user){
      params.dir_maping_id = this.userApi.data.directorat_maping_id;
    }
    this.masterApi.getDivisi(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.divisi_user){
          if(this.userApi.data.division_maping_id==rec.maping_id){
            rec.selected = 1;
            this.divisi_selected.push(rec.maping_id);
          }
        }else{
          rec.selected = 1;
          this.divisi_selected.push(rec.maping_id);
        }
      });
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      this.divisi = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getBranch(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.getBranch(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.advance_type=='HO'){
          rec.selected = 1;
          this.branch_selected.push('00');
        }else{
          rec.selected = 1;
          this.branch_selected.push(rec.office_code);
        }
      });
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      this.branch = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  // public getFilterStage(){
  //   let params : {};
  //   this.masterApi.filterStage(params).subscribe((resp:any) => {
  //     resp.data.forEach(rec => {
  //       rec.selected = 1;
  //       this.filter_stage_selected.push(rec.id);
  //     });
  //     this.readyFilter++;
  //     if(this.readyFilter==6){
  //       this.changeFilter();
  //     }
  //     this.filter_stage = resp.data;
  //   });
  // }

  public getRate(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.getRate(params).subscribe((resp:any) => {
      this.rate = resp.data;
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  public getDataAdvanceStat(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.dashboard.getAdvanceStat(params).subscribe((resp:any) => {
      this.advanceStat = resp.data_by_rate;
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      loading.dismiss();
    },(err) => {
      this.presentToast('Failed to Load Data.');
      loading.dismiss();
    });
  }

  filterBar(){
    this.dataBar =[];
    this.dataBar['all']=0;
      this.advanceStat.forEach(rec1 => {
        let andCompany     = this.company_selected.indexOf(rec1.company_id);
        let andDirectorat = this.direktorat_selected.indexOf(rec1.directorat_maping_id);
        let andDivision   = this.divisi_selected.indexOf(rec1.division_maping_id);
        let andBranch     = this.branch_selected.indexOf(rec1.office_code);

        if(andCompany!=-1 && andDirectorat!=-1 && andDivision!=-1 && andBranch!=-1){
          if(this.dataBar[rec1.advance_rate_id]==undefined){
              this.dataBar[rec1.advance_rate_id] = 0;
          }
          this.dataBar[rec1.advance_rate_id] += parseInt(rec1.advance_count);     
        }
      });
      
      this.barChartData = [];
      this.rate.forEach(rateRow => {
        let jml = 0;
        if(this.dataBar[rateRow.id]){
          jml = parseInt(this.dataBar[rateRow.id]);
          this.barChartData.push({data: [jml], label: rateRow.rate});
        }else{
          this.barChartData.push({data: [jml], label: rateRow.rate});
        }
        this.dataBar['all'] += jml;
      });
      this.barChartData.push({data: [this.dataBar['all']], label: 'All'});
    }

  filterDepartment(){
    let tempIndex = [];
    this.listPerDepartment = [];
    let i = 0;
    this.AllDepartment = 0;
    let tempAdvanceStat = this.advanceStat;
    tempAdvanceStat.forEach( rec2 => {
      let andCompany    = this.company_selected.indexOf(rec2.company_id);
      let andDirectorat = this.direktorat_selected.indexOf(rec2.directorat_maping_id);
      let andDivision   = this.divisi_selected.indexOf(rec2.division_maping_id);
      let andBranch     = this.branch_selected.indexOf(rec2.office_code);
      // let andStage   = this.filter_stage_selected.indexOf(rec2.classification_id);
      if(andCompany!=-1 && andDirectorat!=-1 && andDivision!=-1 && andBranch!=-1){
        if(tempIndex[rec2.department_id]==undefined){
          let temp = {
            advance_count   : parseInt(rec2.advance_count),
            directorat_name : rec2.directorat_short_name,
            division_id     : rec2.division_maping_id,
            division_name   : rec2.division_short_name,
            department_id   : rec2.department_id,
            department_name : rec2.department_name,
            office_code     : rec2.office_code,
            total_amount    : rec2.total_amount
          }
          tempIndex[rec2.department_id]=i;
          i++;
          this.listPerDepartment.push(temp);
        }
        else{
          this.listPerDepartment[ tempIndex[rec2.department_id] ].advance_count += parseInt(rec2.advance_count);
        }
        this.AllDepartment += parseInt(rec2.advance_count); 
        
      }

    });
    console.log("data dept => ", this.listPerDepartment);
  }

  ubahAdvType(){
    console.log("advance type => ",this.advance_type);
    if(this.advance_type=='HO'){
      this.changeFilter('branch');
    }else{
      this.direktorat_all_selected = 0;
      this.divisi_all_selected = 0;
      this.branch_all_selected = 0;
      this.direktoratClickAll();
      this.divisiClickAll();
      this.branchClickAll();
    }
  }

  public companyClick(i){
    if(this.direksi_user){
      return;
    }
    this.company[i].selected = !this.company[i].selected;
    this.changeFilter('company');
  }

  public companyClickAll(){
    this.company_all_selected = !this.company_all_selected;
    this.company.forEach(rec => {
      rec.selected = this.company_all_selected;
    });
    this.changeFilter('company');
  }

  public direktoratClick(i, map_id){
    if(this.direksi_user || this.divisi_user){
      return;
    }
    this.direktorat[i].selected = !this.direktorat[i].selected;
    console.log('direktorat selected => ', this.direktorat_selected.join(','));
    this.changeFilter('direktorat');
  }

  public direktoratClickAll(){
    if(this.direksi_user || this.divisi_user){
      return;
    }
    this.direktorat_all_selected = !this.direktorat_all_selected;
    this.direktorat.forEach(rec => {
      rec.selected = this.direktorat_all_selected;
    });
    this.changeFilter('direktorat');
  }

  public divisiClick(i){
    if(this.divisi_user){
      return;
    }
    this.divisi[i].selected = !this.divisi[i].selected;
    this.changeFilter('divisi');
  }

  public divisiClickAll(){
    if(this.divisi_user){
      return;
    }
    this.divisi_all_selected = !this.divisi_all_selected;
    this.divisi.forEach(rec => {
      rec.selected = this.divisi_all_selected;
    });
    this.changeFilter('divisi');
  }

  public branchClick(i){
    // if(this.branch_user){
    //   return;
    // }
    this.branch[i].selected = !this.branch[i].selected;
    this.changeFilter('branch');
  }

  public branchClickAll(){
    // if(this.branch_user){
    //   return;
    // }
    this.branch_all_selected = !this.branch_all_selected;
    this.branch.forEach(rec => {
      rec.selected = this.branch_all_selected;
    });
    this.changeFilter('branch');
  }

  // public stageClick(i){
  //   this.filter_stage[i].selected = !this.filter_stage[i].selected;
  //   this.changeFilter('stage');
  // }
 
  public changeFilter(opt=''){

    if(opt=='branch' || opt==''){
      let all = 1;
      this.branch_selected = [];
      this.branch.forEach(rec => {
        if(this.advance_type=='HO'){
          this.branch_selected.push('00');
        }else{
          if(rec.selected){
            this.branch_selected.push(rec.office_code);
          }else{
            all = 0;
          }
        }
      });
      this.branch_all_selected = all;
    } 

    if(opt=='divisi' || opt==''){
      let all = 1;
      this.divisi_selected = [];
      this.divisi.forEach(rec => {
        if(rec.selected){
          this.divisi_selected.push(rec.maping_id);
        }else{
          all = 0;
        }
      });
      this.divisi_all_selected = all;
    } 

    if(opt=='direktorat'  || opt==''){
      let all = 1;
      this.direktorat_selected = [];
      this.direktorat.forEach(rec => {
        if(rec.selected){
          this.direktorat_selected.push(rec.maping_id);
        }else{
          all = 0;
        }
      });
      this.direktorat_all_selected = all;
    }

    if(opt=='company'  || opt==''){
      let all = 1;
      this.company_selected = [];
      this.company.forEach(rec => {
        if(rec.selected){
          this.company_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.company_all_selected = all;
    }

    // if(opt=='stage' || opt==''){
    //   let all = 1;
    //   this.filter_stage_selected = [];
    //   this.filter_stage.forEach(rec => {
    //     if(rec.selected){
    //       this.filter_stage_selected.push(rec.id);
    //     }else{
    //       all = 0;
    //     }
    //   });
    //   this.filter_stage_all_selected = all;
    // }

    this.filterBar();
    this.filterDepartment();
  }


  public chartClicked(e:any):void {

  }

  toListEmployee(department_id='', division_id='') {
    let params:any = {};
    if(department_id!=''){
      params.department_id = department_id;
    }
    if(division_id!='' && division_id!=undefined){
      params.division_id  = division_id;
    }
    params.all_divisi      = this.divisi_all_selected;
    params.all_company     = this.company_all_selected;
    params.all_direktorat  = this.direktorat_all_selected;
    params.all_branch      = 0;

    if(division_id=='' || division_id==undefined){
      params.division_ids    = this.divisi_selected.join(',');
    }
    params.company_ids     = this.company_selected.join(',');
    params.directorat_ids  = this.direktorat_selected.join(',');
    params.branch_ids      = this.branch_selected.join(',');

    params.advance_type    = this.advance_type;
    // params.classification_ids = this.filter_stage_selected.join(',');
    this.navCtrl.push(ListEmployeePage,{
      params : params
    });
  }

  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }


  // confirmLogout() {
  //   const confirm = this.alertCtrl.create({
  //     title: 'Yakin akan keluar ?',
  //     buttons: [
  //       {
  //         text: 'Tidak',
  //         handler: () => {

  //         }
  //       },
  //       {
  //         text: 'Ya',
  //         handler: () => {
  //           this.logout();
  //         }
  //       }
  //     ]
  //   });
  //   confirm.present();
  // }

  // logout(){
  //   localStorage.clear();
  //   this.navCtrl.push(LoginPage);
  // }

  // toProfile(){
  //   this.navCtrl.push(ProfilePage);
  // }

 
}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/home/home.ts